import WsProvider from './provider/WSProvider';

var serviceName = 'webservis';
var moduleName = 'yapiRuhsat';

var ruhsatService = {
    path: WsProvider.apiPath + 'belge/yapiruhsat/',
    musteriListele(cariDurumu, baslangic = 0, limit = 10000) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[durum]': cariDurumu,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            serviceName: 'musteri',
            methodName: 'musteriListesi',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });

        return result;
    },
    ruhsatDetay(musteriID, projeID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[musteriID]': musteriID,
            'data[projeID]': projeID,
            serviceName: moduleName,
            methodName: 'RuhsatDetay',
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
        return result;
    },
    createRuhsatFiles({musteriID, projeID, images, baslik, belge, updateID}) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            [`data[${!updateID ? 'musteriID' : 'musteriID'}]`]: !updateID ? musteriID : musteriID,
            [`data[${!updateID ? 'projeID' : 'id'}]`]: !updateID ? projeID : updateID,
            'data[baslik]': baslik,
            'belge': belge,
            methodName: !updateID ? 'RuhsatEkle' : 'RuhsatGuncelle',
            serviceName: moduleName,
        };
        if (images !== undefined && typeof images.forEach === 'function') {
            images.forEach((item, index) => (param[`resim[${index}]`] = item));
        }
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    ruhsatListele(arsaDurumu, baslangic = 0, limit = 10000) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[durum]': arsaDurumu,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            methodName: 'RuhsatListele',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
        return result;
    },
    ruhsatArama(musteriAdi, projeAdi, arsaDurumu, baslangic, limit) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[musteriAdi]': musteriAdi,
            'data[projeAdi]': projeAdi,
            'data[ruhsatDurumu]': arsaDurumu,
            'data[baslangic]': baslangic,
            'data[limit]': limit,
            methodName: 'RuhsatAra',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
        return result;
    },
    ruhsatTamamenSil(arsaTahsisID) {
        var userDataDemirag = localStorage.getItem('userDataDemirag');
        var param = {
            token: userDataDemirag,
            'data[yapiRuhsatID]': arsaTahsisID,
            methodName: 'RuhsatTamamenSil',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
        return result;
    },
    ruhsatDosyaSil(id) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            'data[yapiRuhsatID]': id,
            methodName: 'RuhsatSil',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    ruhsatDurumDegis(id, durum) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            'data[id]': id,
            'data[durum]': durum,
            methodName: 'DurumDegistir',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
    sunucuDosyaEkle({musteriID, projeID, baslik, dosyaID}) {
        var token = localStorage.getItem('userDataDemirag');
        var param = {
            token,
            [`data[musteriID]`]: musteriID,
            [`data[projeID]`]: projeID,
            'data[baslik]': baslik,
            'data[dosyaID]': dosyaID,
            methodName: 'dosyaEkle',
            serviceName: moduleName,
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
        return result;
    },
};

export default ruhsatService;
